<div style="
    padding: 3em;
"><div class="alert alert-warning d-flex align-items-center">
<span class="icon">
    <fa-icon [icon]="faExclamationTriangle" size="2x"></fa-icon>
</span>
<div style="padding-left: 10px;"><h2>401 Unauthorized</h2><p>Oops! It looks like you’re not authorized to access this page. Please check your login details and try again. If you think this is a mistake, please contact support or your administrator for assistance.</p></div></div></div>


